// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9b108cec","453":"c3fd0b61","455":"06013bbe"}[chunkId] + ".chunk.js";
};